<template>
  <div>
    <v-row>
      <v-col cols="3" class="mt-3 mb-5">
        <v-row class="text-subtitle"> Nome </v-row>
        <v-row class="text-subtitle"> {{ model.SerasaPF.Nome }} </v-row>
      </v-col>
      <v-col cols="2" class="mt-3 mb-5">
        <v-row class="text-subtitle"> Dt.Nascimento </v-row>
        <v-row class="text-subtitle"> {{ $api.UI.Format.Date(model.SerasaPF.DtNasc) }} </v-row>
      </v-col>
      <v-col cols="2" class="mt-3 mb-5">
        <v-row class="text-subtitle"> Estado Civil </v-row>
        <v-row class="text-subtitle"> {{ model.SerasaPF.EstadoCivil ? `Casado com ${model.SerasaPF.EstadoCivil}` :
          "------" }} </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="2" class="mt-3 mb-5">
        <v-row class="text-subtitle"> Documento </v-row>
        <v-row class="text-subtitle"> {{ $api.UI.Format.DocumentoFederal(model.SerasaPF.DocumentoFederal) }} </v-row>
      </v-col>
    </v-row>

    <span class="text-h5 ml-3 primary--text">Situação Receita Federal</span>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="3" class="mt-3 mb-5">
        <v-row class="text-subtitle"> Situação Receita Federal </v-row>
        <v-row class="text-subtitle"> {{ model.SerasaPF.Situacao }} </v-row>
      </v-col>
      <v-col cols="3" class="mt-3 mb-5">
        <v-row class="text-subtitle">Data Consulta Situação</v-row>
        <v-row class="text-subtitle"> {{ model.SerasaPF.DtSituacao ? $api.UI.Format.Date(model.SerasaPF.DtSituacao) :
          "------" }} </v-row>
      </v-col>
      <v-col cols="2" class="mt-3 mb-5">
        <v-row class="text-subtitle">Score 12 meses</v-row>
        <v-row class="text-subtitle"> {{ model.SerasaPF.Score12Meses }} </v-row>
      </v-col>
      <v-col cols="4" class="mt-3 mb-5">
        <v-row class="text-subtitle">Score Mensagem</v-row>
        <v-row class="text-subtitle"> {{ model.SerasaPF.Score12MesesMSG }} </v-row>
      </v-col>
    </v-row>

    <span class="text-h5 ml-3 primary--text">Pais</span>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="4" class="mt-3 mb-5">
        <v-row class="text-subtitle">Mãe</v-row>
        <v-row class="text-subtitle"> {{ model.SerasaPF.NomeMae ? model.SerasaPF.NomeMae : "------" }} </v-row>
      </v-col>
      <v-col cols="4" class="mt-3 mb-5">
        <v-row class="text-subtitle">Pai</v-row>
        <v-row class="text-subtitle"> {{ model.SerasaPF.NomePai ? model.SerasaPF.NomePai : "------" }} </v-row>
      </v-col>
    </v-row>

    <span class="text-h5 ml-3 primary--text" v-if="dadosSerasaConsultas.length">Consultas</span>
    <v-divider></v-divider>
    <v-row v-for="(item, i) in dadosSerasaConsultas" :key="`${i} + '-consultas'`">
      <v-col v-for="(field, idx) in renderableFields(item)" :key="idx" :cols="12" :md="colSize(item)" class="mt-3 mb-5">
        <v-row class="text-subtitle">{{ field.label }}</v-row>
        <v-row class="text-subtitle">{{ field.value }}</v-row>
      </v-col>
    </v-row>

    <span class="text-h5 ml-3 primary--text" v-if="dadosSerasaRestricoes.length">Restrições</span>
    <v-divider></v-divider>
    <v-row v-for="(item, i) in dadosSerasaRestricoes" :key="`${i} + '-restricoes'`">
      <v-col v-for="(field, idx) in renderableFields(item)" :key="idx" :cols="12" :md="colSize(item)" class="mt-3 mb-5">
        <v-row class="text-subtitle">{{ field.label }}</v-row>
        <v-row class="text-subtitle">{{ field.value }}</v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default ({
  props: {
    model: {}
  },
  data () {
    return {
      carregaModel: false
    }
  },
  methods: {
    renderableFields (item) {
      const fields = [
        { label: 'Nº Contrato', value: item.Contrato },
        { label: 'Protesto de Cartório', value: item.Oficio ? `Cartório Nº ${item.Oficio}` : null },
        { label: 'Data Ocorrência', value: item.DataOcorrencia ? this.$api.UI.Format.Date(item.DataOcorrencia) : null },
        { label: 'Consultor', value: item.Consultor },
        { label: 'Empresa', value: item.NomeEmpresa ? `${item.NomeEmpresa} - ${item.ApelidoEmpresa}` : null },
        { label: 'Documento da empresa', value: item.DocumentoEmpresa ? this.$api.UI.Format.DocumentoFederal(item.DocumentoEmpresa) : null },
        { label: 'Natureza', value: item.Natureza },
        { label: 'Credor', value: item.NomeCredor },
        { label: 'Valor', value: item.Valor ? this.$api.UI.Format.Currency(item.Valor) : null },
        { label: 'Cidade', value: item.Cidade ? (item.UF ? `${item.Cidade} - ${item.UF}` : item.Cidade) : null },
        { label: 'Empresa com falência', value: item.EmpresaFalida },
        { label: 'Cheques sem fundo', value: item.QtdeCheques ? `Cheque Nº ${item.Cheque} | Banco ${item.Banco} - Agência ${item.Agencia}` : null },
        { label: 'Distribuidor', value: item.Distribuidor },
        { label: 'Vara Judicial', value: item.VaraJudicial }
      ]
      return fields.filter(f => f.value)
    },
    colSize (item) {
      const count = this.renderableFields(item).length
      if (count <= 3) return 4
      if (count <= 6) return 3
      return 2
    }
  },
  computed: {
    dadosSerasaConsultas () {
      return this.model.SerasaConsultaDetalhe.filter(item => !item.Oficio)
    },
    dadosSerasaRestricoes () {
      return this.model.SerasaConsultaDetalhe.filter(item => item.Oficio)
    },
  }
})
</script>
